import React from 'react';

const InputRange = ({ name, label, value, onChange, min, max, step, disabled, className = '' }) => {
  return (
    <div className={`form-block custom-range ${className || ''}`}>
      <div>
        {label && (
          <p
            className={`text-lg d-flex mb-4 mb-md-8 align-items-center justify-content-between fw-500 ${
              disabled ? 'text-gray-dark' : ''
            }`}
          >
            <span>{label}</span>
            <span>${value}</span>
          </p>
        )}
        <input
          className='custom-range-input'
          disabled={disabled}
          name={name}
          type='range'
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          step={step}
        />
      </div>
    </div>
  );
};

InputRange.defaultProps = {
  value: '',
  onChange: () => {},
};

export default InputRange;
